<div class="square" [style.background]="color??'#9059B5'" [style.width]="size"  [style.height]="size">
    <p *ngIf="name?.charAt(0)"> {{name?.charAt(0)?.toUpperCase()}}</p>
</div>